import React, { useEffect } from "react";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import { Box, Grid } from "@mui/material";
import Map from "../../../shared/components/Map";
import WorkshopsV2 from "../components/WorkshopsV2";

export default function WorkshopList() {

    const { isDesktop } = useWindowSize();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box className="workshop-list-v2" >
            <Grid container >
                {isDesktop ? (
                    <>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
                            <WorkshopsV2 />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 8 }}>
                            <Map />
                        </Grid>
                    </>
                ) : (
                    <Grid size={{ xs: 12 }}>
                        <WorkshopsV2 />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};